<template>
    <div class="image-slider" :class="{'small': small}">
        <transition-group name="fade" tag="div">
            <div class="slide" v-for="i in [currentIndex]" :key="i" :style="{ backgroundImage: `url(${currentImg})`}"></div>
        </transition-group>
        <div v-if="multipleImages" class="prev" :class="{ showArrows }" @click="prev"><i class="fas fa-chevron-left" /></div>
        <div v-if="multipleImages" class="next" :class="{ showArrows }" @click="next"><i class="fas fa-chevron-right" /></div>
    </div>
</template>

<script>
export default {
  props: ['images', 'small'],

  data () {
    return {
      timer: null,
      currentIndex: 0,
      multipleImages: _.size(this.images) > 1
    }
  },

  mounted: function () {
    this.startSlide()
  },

  methods: {
    startSlide: function () {
      this.timer = this.multipleImages && setInterval(this.next, 4000)
    },

    restartTimer: function () {
      clearInterval(this.timer)
      this.startSlide()
    },

    next: function () {
      if (document.hasFocus()) {
        this.restartTimer()
        this.currentIndex += 1
      }
    },
    prev: function () {
      this.restartTimer()
      this.currentIndex -= 1
    }
  },

  computed: {
    currentImg: function () {
      return this.images[Math.abs(this.currentIndex) % this.images.length]
    },
    showArrows: function () {
      return this.$store.state.ui.scrollPos < 100 && !this.small
    }
  }
}
</script>
